<!--
 * @Descripttion:
 * @version: 0.0.1
 * @Author: ZHJI
 * @Date: 2019-09-25 09:23:56
 * @LastEditors: ZHJI
 * @LastEditTime: 2019-12-09 15:07:58
 -->
<!--  -->
<template>
  <basicContainer>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page="page"
      :before-close="handleClose"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @sort-change="sortChange"
      @on-load="onLoad"
      @refresh-change="refresh"
      @cell-click="cellClick"
      :before-open="beforeOpen"
    >
    <!-- 操作按钮扩展 -->
    <template v-slot:loginNameForm="{ row }">
      <loginInput :formId="form.id" v-model="row.loginName" @setDisable="handleDisable" />
    </template>
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="fa fa-trash-o"
          @click="handleDelete"
        > 删 除</el-button>

        <el-button type="success" size="small"  icon="fa fa-upload"  @click="importExecl"   > 导入</el-button>
        <el-button type="success" size="small"  icon="fa fa-cloud-download"  @click="downloadDataFunc"   > 导出</el-button>
<el-button type="success"  size="small"  icon="fa fa-download"  @click="downloadViewFunc"   > 下载模板</el-button>
      </template >
      <!-- 关联角色,关联机构 -->
      <template v-slot:menu=" {row, index}" >
        <el-button type="text" icon="el-icon-edit" size="small" @click.stop="handleEdit(row, index)">编辑</el-button>
        <el-button type="text" icon="el-icon-delete" size="small" @click.stop="rowDel(row, index)">删除</el-button>
        <el-button type="text" size="small"  icon="fa fa-eye"  @click="concatRole(row)"> 关联角色</el-button>
        <el-button type="text" size="small"  icon="fa fa-eye"  @click="concatorgan(row)"> 关联机构</el-button>
        <!--todo <el-button type="text" size="small"  icon="fa fa-eye"  @click=""   > 配置关系人</el-button> -->
      </template>
    <!-- 状态栏目扩展  -->
    <template v-slot:status="{row,label}" >
      <el-tag v-if="label === '正常'" type="success">{{label}}</el-tag>
      <el-tag v-else-if="label === '冻结'" type="info">{{label}}</el-tag>
      <el-tag v-else type="danger">{{label}}</el-tag>
    </template>
    <!-- 密码强度栏目扩展  -->
    <template v-slot:currentPasswordStrength="{row,label}" >
      <el-tag v-if="label === '非常弱'" type="danger">{{label}}</el-tag>
      <el-tag v-else-if="label === '弱'" type="warning">{{label}}</el-tag>
      <el-tag v-else-if="label === '一般'" type="info">{{label}}</el-tag>
        <el-tag v-else-if="label === '强'" type="success">{{label}}</el-tag>
      <el-tag v-else type="success">{{label}}</el-tag>
    </template>

    </avue-crud>
    <!-- 下载模板选择试图 -->
      <el-dialog  title="模板下载"  :visible.sync="downloadView.show" width="30%" top="15vh" :append-to-body="true">
        <el-row>
          <el-form :inline="true"  ref="downloadView" :model="downloadView.form" label-suffix=":">
            <el-col :span="24">
              <el-form-item label="模板类型" prop="excelTemplateType" :rules="[{ 'required': true, 'message': '请选择模板类型' }]"  :required="true">
                <el-radio-group v-model="downloadView.form.excelTemplateType">
                  <el-radio label="save" >保存模板</el-radio>
                  <el-tooltip class="item" effect="dark" content="可使用数据导出的exxecl作为该模板" placement="bottom">
                    <el-radio label="update">修改模板</el-radio>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="可使用数据导出的exxecl作为该模板" placement="bottom">
                    <el-radio label="delete">删除模板</el-radio>
                  </el-tooltip>

                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="文件名称"  prop="fileName" :rules="[{ 'required': true, 'message': '请输入文件名' }]"  :required="true">
                <el-input v-model="downloadView.form.fileName">
                  <template slot="append">.xls</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
        <span slot="footer" >
          <el-button @click="downloadView.show = false">取 消</el-button>
          <el-button type="primary" @click="toDownloadView">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 下载数据选择试图 -->
      <el-dialog  title="数据导出" :visible.sync="downloadData.show" width="30%" top="15vh" :append-to-body="true">
        <el-row>
          <el-form :inline="true"  ref="downloadData" :model="downloadData.form" label-suffix=":">
            <el-col :span="24">
              <el-form-item label="文件名称"  prop="fileName" :rules="[{ 'required': true, 'message': '请输入文件名' }]"  :required="true">
                <el-input v-model="downloadData.form.fileName">
                  <template slot="append">.xls</template>
                </el-input>
              </el-form-item>
              <el-form-item label="导出方案" prop="downloadFA" :rules="[{ 'required': true, 'message': '请选导出方案' }]"  :required="true">
                <el-radio-group v-model="downloadData.form.downloadFA">
                  <el-radio label="all" >全部导出</el-radio>
                <el-radio label="notall" >条件导出</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
        <span slot="footer" >
          <el-button @click="downloadData.show = false">取 消</el-button>
          <el-button type="primary" @click="toDownloadData">确 定</el-button>
        </span>
      </el-dialog>
       <!-- 关联角色 -->
      <el-dialog   :visible.sync="concatData.userConcatRoleShow" width="70%" top="5vh" :append-to-body="true">
        <userConcatRole ref="userConcatRole" :optionRow="concatData.optionRow"/>
      </el-dialog>
      <!-- 关联机构 -->
      <el-dialog   :visible.sync="concatData.userConcatOrganShow" width="70%" top="5vh" :append-to-body="true">
        <userConcatOrgan ref="userConcatOrgan" :optionRow="concatData.optionRow"/>
      </el-dialog>
       <!-- 下载数据选择试图 -->
      <el-dialog  title="导入数据"  @close="importEceclClose" :visible.sync="uploadView.show" width="30%" top="15vh" :append-to-body="true">
        <el-row>
          <el-form :inline="true"  ref="uploadView" :model="uploadView.form" label-suffix=":">
            <el-col :span="24">
              <el-form-item label="模板类型" prop="excelTemplateType" :rules="[{ 'required': true, 'message': '请选择模板类型' }]"  :required="true">
                <el-radio-group v-model="uploadView.form.excelTemplateType">
                  <el-radio label="save" >批量保存</el-radio>
                  <el-radio label="update">批量修改</el-radio>
                  <el-radio label="delete">批量删除</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="24">
                <!-- <input type="file" class="file" @change="uploading($event)" /> -->
                <input type="file"  ref="referenceUpload"  class="file" @change="uploading($event)">
                <el-button type="success" class="file_btn"><i class="el-icon-upload"></i><span v-text="uploadView.label">上传文件</span></el-button>
            </el-col>
          </el-form>
        </el-row>
        <span slot="footer" >
          <el-button @click="uploadView.show = false">取 消</el-button>
          <el-button type="primary" @click="updateFile">确 定</el-button>
        </span>
      </el-dialog>
  </basicContainer>
</template>

<script>
import { checkPassword } from '@/framework/util/util'
import { optionConfig } from '@/framework/util/optionConfig'
export default {
  name: 'UserManage',
  data() {
    return {

      uploadView: {
        show: false,
        label: '上传文件',
        form: {}
      },
      concatData: {
        userConcatRoleShow: false,
        userConcatOrganShow: false,
        optionRow: {}
      },
      downloadView: {
        show: false,
        form: {
          excelTemplateType: '',
          fileName: '用户管理模板'
        }
      }, downloadData: {
        show: false,
        form: {
          fileName: '用户管理数据',
          downloadFA: 'all'
        }
      },
      form: {},
      formDisable: false,
      order: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      selectionList: [],
      data: []

    }
  },

  computed: {
    option: function() {
      const tableOption = {
        dialogHeight: 400,
        menuWidth: 300,
        height: 'auto',
        calcHeight: 150,
        searchMenuSpan: 6,
        align: 'center',
        tip: false,
        stripe: true,
        border: true,
        index: true,
        viewBtn: false,
        editBtn:false,
        delBtn: false,
        selection: true,
        column: [
          {
            label: '登录名',
            prop: 'loginName',
            width: 200,
            search: true,
            sortable: true,
            formslot: true,
            rules: [{
              required: true,
              message: '请输入登录名',
              trigger: 'blur'
            }]
          }, {
            label: '密码',
            viewDisplay: false,
            prop: 'userPassword',
            showColumn: false,
            hide: true,
            append: '0分',
            type: 'password',
            change: ({ value, column }) => {
              let passScore = checkPassword(value)
              column.append = passScore < 20 ? '非常弱' : passScore < 40 ? '弱' : passScore < 60 ? '一般' : passScore < 80 ? '强' : '非常强'
            },
            rules: [{
              required: true,
              message: '请输入密码',
              trigger: 'blur'
            }]
          }, {
            label: '姓名',
            prop: 'name',
            type: 'input',
            width: 200,
            sortable: true,
            search: true,
            rules: [{
              required: true,
              message: '请输入姓名',
              trigger: 'blur'
            }]
          }, {
            label: '昵称',
            prop: 'nickName',
            type: 'input',
            hide: true
          }, {
            label: '手机号码',
            prop: 'mobile',
            type: 'input',
            sortable: true,
            rules: [
              {
                required: true,
                trigger: 'blur',
                'message': '请输入手机号码'
              }
            ]
          }, {
            label: '身份证号',
            prop: 'idCard',
            type: 'input',
            hide: true,
            rules: [
              {
                'validator': (rule, idcode, callback) => {
                  if (!idcode) {
                    return callback()
                  }
                  if (idcode.length <= 17) {
                    return callback('请输入18位身份证号')
                  } else {
                    return callback()
                  }
                }
              }
            ]
          }, {
            label: '校园邮箱',
            prop: 'schoolEmail',
            type: 'input',
            sortable: true,
            rules: [{
              'pattern': '^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$',
              'message': '校园邮箱 格式错误'
            }]
          }, {
            label: '邮箱',
            prop: 'email',
            hide: true,
            type: 'input',
            rules: [{
              'pattern': '^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$',
              'message': '邮箱 格式错误'
            }]
          },
          {
            label: '状态',
            prop: 'status',
            sortable: true,
            type: 'select',
            slot: true,
            search: true,
            width: 120,
            dicData: [{
              label: '正常',
              value: 1
            }, {
              label: '冻结',
              value: 2
            }, {
              label: '过期',
              value: 3
            }],
            rules: [{
              required: true,
              message: '请选择状态',
              trigger: 'blur'
            }]
          },
          {
            label: '密码强度',
            addDisplay: false,
            sortable: true,
            editDisplay: false,
            prop: 'currentPasswordStrength',
            type: 'select',
            slot: true,
            width: 130,
            dicData: [{
              label: '非常弱',
              value: '1'
            }, {
              label: '弱',
              value: '2'
            }, {
              label: '一般',
              value: '3'
            }, {
              label: '强',
              value: '4'
            }, {
              label: '非常强',
              value: '5'
            }]
          },
          {
            label: '期望强度',
            prop: 'passwordStrength',
            hide: true,
            type: 'select',
            dicData: [{
              label: '非常弱',
              value: '1'
            }, {
              label: '弱',
              value: '2'
            }, {
              label: '一般',
              value: '3'
            }, {
              label: '强',
              value: '4'
            }, {
              label: '非常强',
              value: '5'
            }],
            rules: [{
              required: true,
              message: '请选择期望的密码强度',
              trigger: 'blur'
            }]
          },
          {
            label: '过期时间',
            prop: 'lifeTime',
            sortable: true,
            'type': 'date',
            'format': 'yyyy-MM-dd',
            'valueFormat': 'yyyy-MM-dd'

          }
        ]
      }
      tableOption.column.map(item => {
        if (item.prop !== 'loginName') {
          item.addDisabled = this.formDisable
        }
      })
      return tableOption
    }
  },

  components: {
    userConcatOrgan: () => import('./internalComponents/userConcatOrgan'),
    userConcatRole: () => import('./internalComponents/userConcatRole'),
    loginInput: () => import('./loginInput')
  },

  mounted() {
    this.option = optionConfig(this.option)
  },
  methods: {
    handleEdit(row, index) {
      this.option.column[1].rules[0].required = false
      this.$refs.crud.rowEdit(row, index)
    },
    handleClose(done,type) {
      this.option.column[1].rules[0].required = true
      done()
    },
    handleDisable(data) {
      if (data) {
        const {
          nickName,
          name,
          status,
          passwordStrength
        } = data
        this.form = {
          ...this.form,
          nickName,
          name,
          status,
          passwordStrength
        }
        this.formDisable = true
        this.$message.success('此用户已经存在')
      } else {
        this.form.nickName = ''
        this.form.name = ''
        this.form.status = ''
        this.form.passwordStrength = ''
        this.formDisable = false
      }
    },
    cellClick: function(row, column, cell, event) {
      if (column.label !== '操作') {
        this.$refs.crud.toggleRowSelection(row)
      }
    },
    refresh: function() {
      this.onLoad()
    },
    sortChange(value) {
      this.order.prop = value.prop
      this.order.order = value.order
      this.onLoad()
    },
    searchReset() {
      this.query = {}
      this.page.currentPage = 1
      this.onLoad()
    },
    searchChange(params, done) {
      for (let key in params) {
        if (params[key] === '') {
          delete params[key]
        }
      }
      done()
      this.page.currentPage = 1
      this.query = params
      this.onLoad()
    },
    selectionClear() {
      this.selectionList = []
      this.$refs.crud.toggleSelection()
    },
    selectionChange(list) {
      this.selectionList = list
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize
    },
    rowSave(row, loading, done) {
      if (!row.userPassword || row.userPassword.length < 6) {
        return this.$message.warning('新增用户时,必须为用户填写密码,且密码长度需要大于 6 位。') && done()
      }
      let passScore = checkPassword(row.userPassword)
      row.currentPasswordStrength = passScore < 20 ? 1 : passScore < 40 ? 2 : passScore < 60 ? 3 : passScore < 80 ? 4 : 5
      this.$http.post('/account', [row])
        .then(response => {
          this.$message.success('添加用户成功') && loading()
          this.onLoad()
        }).catch(error => {
          this.$message.error(error.msg) && done()
        })
    },
    rowUpdate(row, index, loading, done) {
      if (row.userPassword && row.userPassword.length < 6) {
        return this.$message.warning('编辑用户时,如需要修改用户密码,密码长度需要大于 6 位。') && done()
      }
      if (!row.lifeTime) {
        row.lifeTime = ''
      }
      this.$http.put('/account', [row])
        .then(response => {
          this.$message.success('编辑用户成功') && loading()
          this.onLoad()
        }).catch(error => {
          this.$message.error(error.msg) && done()
        })
    },
    rowDel(row, index) {
      this.deleteRows([row], () => {
        this.data.splice(index, 1)
      })
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        return this.$message.warning('请选择至少一条数据')
      }
      this.deleteRows(this.selectionList, () => {
        this.onLoad()
      })
    },
    deleteRows: function(deleteList, callback) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/account/delete', {}, { params: { accountIdList: deleteList.map(item => item.id) }}).then(
          response => {
            this.$message.success('删除成功') && typeof callback === 'function' && callback()
          }).catch(error => {
          this.$message.error(error.msg)
        })
      }).catch(e => {})
    },
    onLoad(page = this.page, params = this.query, order = this.order) {
      let orderItemList = []
      if (order.order) {
        orderItemList.push({
          asc: order.order === 'ascending',
          column: order.prop
        })
      }
      this.loading = true
      this.$http.post('/account/query', { 'entity': params, orderItemList }, { params: {
        pageNum: page.currentPage,
        pageSize: page.pageSize
      }}).then(
        response => {
          this.loading = false
          this.data = response.data.records
          this.page.total = response.data.total || response.data.records.length
          this.selectionClear()
        }
      ).catch(
        error => {
          this.loading = false
          this.$message.error(error.msg)
        }
      )
    }, downloadViewFunc: function() {
      this.downloadView.show = true
      if (this.$refs.downloadView) {
        this.$refs.downloadView.resetFields()
      }
      this.downloadView.form = {
        excelTemplateType: '',
        fileName: '用户管理模板'
      }
    }, toDownloadView: function() {
      this.$refs.downloadView.validate((valid) => {
        if (valid) {
          this.$downloadFile.get('/account/excel/template-export', { params: {
            excelTemplateType: this.downloadView.form.excelTemplateType,
            fileName: this.downloadView.form.fileName + '.xls',
            doDownload: true
          }}).then(response => {
            this.downloadView.show = false
            // 返回的内容
          }).catch(e => this.$message.error(e.msg))
        }
      })
    }, downloadDataFunc: function() {
      this.downloadData.show = true
      if (this.$refs.downloadData) {
        this.$refs.downloadData.resetFields()
      }
      this.downloadData.form = {
        fileName: '用户管理数据'
      }
    },
    toDownloadData: function() {
      this.$refs.downloadData.validate((valid) => {
        if (valid) {
          if (this.downloadData.form.downloadFA === 'all') {
            this.$downloadFile.post('/account/excel/export', { entity: {}}, { params: {
              fileName: this.downloadData.form.fileName + '.xls',
              doDownload: true
            }}).then(response => {
              this.downloadData.show = false
            // 返回的内容
            }).catch(e => this.$message.error(e.msg))
          } else {
            this.$downloadFile.post('/account/excel/export', { entity: this.query }, { params: {
              fileName: this.downloadData.form.fileName + '.xls',
              doDownload: true
            }}).then(response => {
              this.downloadData.show = false
            // 返回的内容
            }).catch(e => this.$message.error(e.msg))
          }
        }
      })
    },
    /**
     * 导入execl 框框关闭
     */
    importEceclClose() {
      this.uploadView.label = '上传文件'
      this.uploadView.form.file = null
      this.$refs.referenceUpload.value = null
    },
    uploading(event) {
      this.uploadView.form.file = event.target.files[0]// 获取文件
      var windowURL = window.URL || window.webkitURL
      this.uploadView.form.file = event.target.files[0]
      // 创建图片文件的url
      this.uploadView.form.src = windowURL.createObjectURL(event.target.files[0])
      this.uploadView.form.label = this.uploadView.form.file.name
      this.uploadView.label = this.uploadView.form.file.name
    },
    updateFile: function() {
      this.$refs.uploadView.validate((valid) => {
        if (valid) {
          if (!this.uploadView.form.file) {
            0
            return this.$message.error('请选择文件')
          }
          let formData = new window.FormData() // vue 中使用 window.FormData(),否则会报 'FormData isn't definded'
          formData.append('file', this.uploadView.form.file)
          this.$http.post('/account/excel/import', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }, params: {
              excelType: this.uploadView.form.excelTemplateType
            }
          }).then((res) => {
            this.$message.success('文件上传成功!')
            // this.uploadView.show = false
            window.location.reload()
          }).catch((error) => {
            this.$message.error(error.msg)
          })
        }
      })
    },
    /**
     * 导入execl
     */
    importExecl: function() {
      this.uploadView.show = true
    },
    /**
     *  关联角色
     */
    concatRole: function(row) {
      this.concatData.optionRow = row
      this.concatData.userConcatRoleShow = true
      this.$nextTick(() => {
        this.$refs.userConcatRole.getAllRole()
      })
    },
    /**
     *  关联机构
     */
    concatorgan: function(row) {
      this.concatData.optionRow = row
      this.concatData.userConcatOrganShow = true
      this.$nextTick(() => {
        this.$refs.userConcatOrgan.getAllOrgan()
      })
    },
    /**
     * 打开前回调
     */
    beforeOpen(done, type) {
      if (type === 'add') return done()
      this.loading = true
      this.$http.get(`/account/${this.form.id}`).then(res => {
        Object.assign(this.form, res.data)
        this.loading = false
        done()
      }).catch(e => {
        this.loading = false
        this.$message.error(e.msg || e.message)
      })
    }

  }
}
</script>
<style lang='scss' scoped>
 .file {
        z-index: 999;
        opacity: 0;
        position: absolute;
        left: 2px;
        width: 8.75rem;
        cursor: pointer;
        height: 2.75rem;
    }
    .file_btn {
        position: absolute;
        left: 2px;
        width: auto;
        z-index: 0;
    }
</style>
